import { Box, Button, Paper } from '@mui/material'
import React from 'react'
import { Department } from 'enums/department'

import { useDispatch } from 'react-redux'

import MixingInventoryList from 'components/production/mixingInventoryList'

export default function MixingInventory(props: { department: Department }) {
  const [isComplete, setIsComplete] = React.useState(false)

  const dispatch = useDispatch()
  React.useEffect(() => {
    const title = props.department
      ? `Daftar Mixing (${props.department.toUpperCase()})`
      : 'Daftar Mixing'
    dispatch({ type: 'SET_PAGE_TITLE', payload: title })
  }, [dispatch, props.department])

  return (
    <Box>
      <Box display="flex" justifyContent="flex-end" mb={2} mt={3}>
        <Button
          variant={!isComplete ? 'contained' : 'outlined'}
          color="primary"
          onClick={() => setIsComplete(false)}
          style={{ marginRight: 8 }}
        >
          Aktif
        </Button>
        <Button
          variant={isComplete ? 'contained' : 'outlined'}
          color="primary"
          onClick={() => setIsComplete(true)}
        >
          Riwayat
        </Button>
      </Box>
      <Paper>
        {/* <Box p={2} pb={2}>
          <Button variant="contained" color="primary" onClick={exportData}>
            Export seluruh data
          </Button>
        </Box> */}
        <Box mt={1} />
        <MixingInventoryList
          isComplete={isComplete}
          department={props.department}
        />
      </Paper>
    </Box>
  )
}
